import React from "react";
import { Bone } from "../common/skeletons";
import SingleUserSearch from "./SingleUserSearch";

const USER_TYPE_OPTIONS = [
  { value: "", label: "All Users" },
  { value: "premium", label: "Premium Users" },
  { value: "non-premium", label: "Non-Premium Users" },
  { value: "single-user", label: "Single User" },
];

const inputClass =
  "text-xs md:text-sm w-full p-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white text-gray-700 min-w-0";
const labelClass = "block text-sm font-semibold text-gray-700 mb-2";

export default function TargetAudienceFilters({
  userType,
  onUserTypeChange,
  country,
  onCountryChange,
  countries,
  loadingCountries,
  phoneVerified,
  profileCompletion,
  lastActive,
  onFilterChange,
  // Single user
  isSingleUser,
  userSearchQuery,
  onUserSearchQueryChange,
  onSearchUser,
  onClearUser,
  searchingUser,
  searchedUser,
}) {
  return (
    <div className="border-t border-gray-200 pt-6 mt-6">
      <h4 className="text-base md:text-lg font-bold mb-4 text-gray-800">
        Target Audience Filters
      </h4>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="min-w-0">
          <label htmlFor="userType" className={labelClass}>
            User Type
          </label>
          <select
            id="userType"
            value={userType}
            onChange={(e) => onUserTypeChange(e.target.value)}
            className={`${inputClass} disabled:bg-gray-100 disabled:cursor-not-allowed`}>
            {USER_TYPE_OPTIONS.map((opt) => (
              <option key={opt.value || "all"} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        {isSingleUser && (
          <SingleUserSearch
            value={userSearchQuery}
            onChange={onUserSearchQueryChange}
            onSearch={onSearchUser}
            onClear={onClearUser}
            loading={searchingUser}
            user={searchedUser}
          />
        )}

        {!isSingleUser && (
          <div className="min-w-0">
            <label htmlFor="country" className={labelClass}>
              Country
            </label>
            <select
              id="country"
              value={country}
              onChange={(e) => onCountryChange(e.target.value)}
              disabled={loadingCountries}
              className={`${inputClass} disabled:bg-gray-100 disabled:cursor-not-allowed`}>
              <option value="">All Countries</option>
              {countries.map((c, i) => (
                <option key={i} value={c}>
                  {c}
                </option>
              ))}
            </select>
            {loadingCountries && (
              <div className="mt-1.5 space-y-1.5" role="status" aria-label="Loading countries">
                <Bone className="h-2.5 w-28" />
                <Bone className="h-2.5 w-20" />
              </div>
            )}
          </div>
        )}
      </div>

      {!isSingleUser && (
        <div className="mt-4 space-y-2">
          {[
            {
              id: "phoneVerified",
              checked: phoneVerified,
              label: "Users without phone number verified",
            },
            {
              id: "profileCompletion",
              checked: profileCompletion,
              label: "Users with profile completion less than 70%",
            },
            {
              id: "lastActive",
              checked: lastActive,
              label: "Last active over a month ago",
            },
          ].map(({ id, checked, label }) => (
            <div key={id} className="flex items-center">
              <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={(e) => onFilterChange(id, e.target.checked)}
                className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded cursor-pointer flex-shrink-0"
              />
              <label
                htmlFor={id}
                className="ml-3 block text-xs md:text-sm font-medium text-gray-700 cursor-pointer">
                {label}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
